var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center"},[_vm._v("   ")])
}
var staticRenderFns = []

export { render, staticRenderFns }